/**
 * Behuli Quick Add to Cart
 * Handles adding products directly to cart from collection/product cards
 * without navigating to the product page.
 */

(function () {
  'use strict';

  // ─── Utility: Add to Cart via Shopify AJAX API ───────────────────────────────
  async function addToCart(variantId, quantity, btn) {
    if (!variantId) return;

    const container = btn.closest('.behuli-quick-add');
    setLoadingState(btn, container, true);

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
      });

      if (!response.ok) {
        const err = await response.json();
        throw new Error(err.description || 'Could not add to cart');
      }

      // Success
      setSuccessState(btn, container);

      // Update cart count bubble(s) in the header
      refreshCartCount();

      // Dispatch custom event so theme cart drawer can open if applicable
      document.dispatchEvent(new CustomEvent('cart:add', { detail: { variantId } }));

    } catch (error) {
      console.error('[Behuli Quick Add] Error:', error);
      setLoadingState(btn, container, false);
      showError(container, error.message);
    }
  }

  // ─── State helpers ───────────────────────────────────────────────────────────
  function setLoadingState(btn, container, isLoading) {
    if (isLoading) {
      btn.disabled = true;
      btn.classList.add('is-loading');
      btn.classList.remove('is-added');
    } else {
      btn.disabled = false;
      btn.classList.remove('is-loading');
    }
  }

  function setSuccessState(btn, container) {
    btn.disabled = false;
    btn.classList.remove('is-loading');
    btn.classList.add('is-added');

    setTimeout(() => {
      btn.classList.remove('is-added');
      if (container) {
        container.classList.remove('is-open');
        const sizePicker = container.querySelector('.behuli-quick-add__size-picker');
        if (sizePicker) sizePicker.classList.remove('is-active');
        container.querySelectorAll('.behuli-quick-add__size-option--selected').forEach(el => {
          el.classList.remove('behuli-quick-add__size-option--selected');
        });
      }
    }, 2000);
  }

  function showError(container, message) {
    if (!container) return;
    container.classList.add('has-error');
    setTimeout(() => container.classList.remove('has-error'), 2000);
  }

  // ─── Cart count refresh ──────────────────────────────────────────────────────
  async function refreshCartCount() {
    try {
      const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      const cart = await res.json();
      const count = cart.item_count;

      const selectors = [
        '.cart-count-bubble span[aria-hidden]',
        '.cart-count-bubble',
        '#cart-icon-bubble .cart-count-bubble span',
        '[data-cart-count]',
        '.header__cart-count',
        '.cart__count',
        '.js-cart-count'
      ];

      selectors.forEach(sel => {
        document.querySelectorAll(sel).forEach(el => {
          el.textContent = count;
          el.setAttribute('aria-label', count + ' items');
        });
      });
    } catch (e) {}
  }

  // ─── Event delegation ────────────────────────────────────────────────────────
  document.addEventListener('click', function (e) {
    // 1. Direct "Add to Cart" button (single-variant products)
    const directBtn = e.target.closest('.behuli-quick-add__btn--direct');
    if (directBtn) {
      e.preventDefault();
      e.stopPropagation();
      const variantId = directBtn.dataset.variantId;
      addToCart(variantId, 1, directBtn);
      return;
    }

    // 2. Size option button click
    const sizeOption = e.target.closest('.behuli-quick-add__size-option');
    if (sizeOption && !sizeOption.classList.contains('behuli-quick-add__size-option--sold-out')) {
      e.preventDefault();
      e.stopPropagation();
      const container = sizeOption.closest('.behuli-quick-add');
      if (!container) return;

      container.querySelectorAll('.behuli-quick-add__size-option').forEach(el => {
        el.classList.remove('behuli-quick-add__size-option--selected');
      });
      sizeOption.classList.add('behuli-quick-add__size-option--selected');

      const multiBtn = container.querySelector('.behuli-quick-add__btn--multi');
      if (multiBtn) {
        multiBtn.dataset.selectedVariantId = sizeOption.dataset.variantId;
      }
      return;
    }

    // 3. "Quick Add" multi-variant button
    const multiBtn = e.target.closest('.behuli-quick-add__btn--multi');
    if (multiBtn) {
      e.preventDefault();
      e.stopPropagation();
      const container = multiBtn.closest('.behuli-quick-add');
      if (!container) return;

      const sizePicker = container.querySelector('.behuli-quick-add__size-picker');
      const selectedVariantId = multiBtn.dataset.selectedVariantId;

      if (!selectedVariantId) {
        if (sizePicker) {
          sizePicker.classList.toggle('is-open');
          container.classList.toggle('is-open');
        }
        return;
      }

      addToCart(selectedVariantId, 1, multiBtn);
      return;
    }

    // 4. Click outside closes open size pickers
    if (!e.target.closest('.behuli-quick-add')) {
      document.querySelectorAll('.behuli-quick-add.is-open').forEach(container => {
        container.classList.remove('is-open');
        const sp = container.querySelector('.behuli-quick-add__size-picker');
        if (sp) sp.classList.remove('is-active');
      });
    }
  });

  // Prevent product card link navigation when clicking inside quick-add
  document.addEventListener('click', function (e) {
    const quickAdd = e.target.closest('.behuli-quick-add');
    if (quickAdd) {
      e.stopPropagation();
      e.preventDefault();
    }
  }, true);

})();